/* PIELURD product detail title fit */
(() => {
  const selectors = '.pw4-pdp__title-row h1, .pw4-pdp h1, .pw3-pdp h1, .product__title h1, .product-title h1';

  const fitTitle = (element) => {
    if (!element.offsetParent) return;
    if (!element.dataset.pwTitleBaseSize) {
      element.dataset.pwTitleBaseSize = String(parseFloat(getComputedStyle(element).fontSize));
    }

    element.classList.add('pw-product-page-title-fit');
    const baseSize = Number(element.dataset.pwTitleBaseSize);
    const minSize = window.matchMedia('(max-width: 749px)').matches ? 16 : 20;
    let size = baseSize;
    element.style.fontSize = '';
    element.style.whiteSpace = 'nowrap';

    while (element.scrollWidth > element.clientWidth + 1 && size > minSize) {
      size -= 0.25;
      element.style.fontSize = size + 'px';
    }
  };

  const fitAll = (root = document) => {
    const titles = root.matches?.(selectors) ? [root] : Array.from(root.querySelectorAll?.(selectors) || []);
    titles.forEach(fitTitle);
  };

  const init = () => {
    fitAll();
    let resizeFrame;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        document.querySelectorAll('.pw-product-page-title-fit').forEach((title) => { title.style.fontSize = ''; });
        fitAll();
      });
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();
})();
